import React, { useCallback, useEffect, useState } from "react";
import List from "../userList";
import Filter from "../userFilterm";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";
import * as ViveroService from "../../../../services/ViveroService";
// import * as WorkingPartServices from "../../../../services/WorkingPartService";
// import moment from "moment-timezone";
// import * as XLSX from "xlsx";
// import { PART_STATUS } from "../../../../constants";
// import { converToTime } from "../../../../utils/formats/number";
import * as GeneralServices from "../../../../services/GeneralServices";
import { SET_FILTER_USER } from "../../../../constants";
import { getFilterUserSelector } from "../../../../store/selectors/navSelector";
import { useSelector } from "react-redux";

const queryClient = new QueryClient();

const UserListContainer = (props) => {
  const { isTechnical } = props;

  const { t } = useTranslation();
  // const [filters, setFilters] = useState(undefined);
  const [viveros, setViveros] = useState([]);
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.users.title") },
  ];
  const filters = useSelector(getFilterUserSelector);

  const loadViveros = useCallback(async () => {
    const resultViveros = await ViveroService.getAllViveros();
    if (resultViveros) {
      setViveros(resultViveros);
    }
  }, []);

  useEffect(() => {
    loadViveros();
  }, [loadViveros]);

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    // setFilters(undefined);
    GeneralServices.setFilter(undefined, SET_FILTER_USER);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });
    // setFilters(newFilter);
    GeneralServices.setFilter(newFilter, SET_FILTER_USER);
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.users.title")}</h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
            viveros={viveros}
            isTechnical={isTechnical}
            initialValues={filters}
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </div>
      </div>
    </>
  );
};

UserListContainer.propTypes = {};

export default UserListContainer;
